import React, { ReactNode } from "react";
import { Box, SxProps, Theme, useTheme } from "@mui/material";

interface ParallaxBackgroundProps {
  backgroundImage: string;
  overlayColor?: string;
  children: ReactNode;
  minHeight?: string;
  maxHeight?: string;
  centerContent?: boolean;
  sx?: SxProps<Theme>;
  offsetTop?: number;
}

const ParallaxBackground: React.FC<ParallaxBackgroundProps> = ({
  backgroundImage,
  overlayColor = "rgba(0, 0, 0, 0.7)",
  children,
  minHeight = "55vh",
  maxHeight,
  centerContent = false,
  sx,
  offsetTop = 70,
}) => {
  const theme = useTheme();
  const computedMinHeight = maxHeight
    ? `min(${minHeight}, ${maxHeight})`
    : minHeight;

  return (
    <Box
      sx={{
        position: "relative",
        backgroundImage: `url(${backgroundImage})`,
        backgroundAttachment: {
          xs: "scroll",
          md: "fixed",
        },
        backgroundSize: "cover",
        backgroundPosition: {
          xs: "center top",
          md: "center",
        },
        color: theme.palette.text.primary,
        minHeight: computedMinHeight,
        ...(maxHeight ? { maxHeight } : {}),
        pt: offsetTop ? `${offsetTop}px` : undefined,
        px: { xs: 2, sm: 4, md: 6 },
        mt: { xs: 4, sm: 0 },
        display: "flex",
        flexDirection: "column",
        justifyContent: centerContent ? "center" : "flex-start",
        alignItems: centerContent ? "center" : "stretch",
        overflow: "hidden",
        ...sx,
      }}
    >
      {/* Overlay oscuro */}
      <Box
        sx={{
          position: "absolute",
          inset: 0,
          backgroundColor: overlayColor,
          zIndex: 0,
        }}
      />
      {/* Contenido */}
      <Box
        sx={{
          position: "relative",
          zIndex: 1,
          width: "100%",
          maxWidth: "1200px",
          mx: "auto",
        }}
      >
        {children}
      </Box>
    </Box>
  );
};

export default ParallaxBackground;
